import { AdminApi } from 'stylemix-vue-admin'

export default class AvailabilityZonesApi extends AdminApi {
  constructor(vehicleId, parameters) {
    super(`vehicles/${vehicleId}/availability-zones`, parameters)
  }
}
